import { render, staticRenderFns } from "./TemplateCertificate.vue?vue&type=template&id=0f0b3c4e&"
import script from "./TemplateCertificate.vue?vue&type=script&lang=js&"
export * from "./TemplateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCertificate.vue?vue&type=style&index=0&id=0f0b3c4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports